// FREE MINDFULNESS AND MEDITATION APPS — LWC Pre-Surgical 6.1 Exercises.
// App-style cards (no linkText): bold title + "Click image or this link".
//
// Links per Jim (10/7): one link per card to the app's official site, same as
// the Stress Reduction page (living_well_center-6-5.js).
// Healthy Minds Innovations is now Humin, so the Healthy Minds Program app
// page moved to humin.org (Jim, 10/7). The app name is unchanged.
//
// Logos: interim Figma graphics hosted by Jim (10/8) until Shad's final set.
// Note: the S3 file "Pre-Surgical App Mindfulness Coach.png" is actually the
// UCLA Mindful icon, so UCLA Mindful uses it on purpose (OK'd as a placeholder,
// 10/8). Mindfulness Coach and Healthy Minds keep the older 6-5 logos.
// Shad's set (10/8) matched the art above at equal or lower resolution, so
// only Insight Timer changed: his dark icon replaces the white framed one.
import { S3, thumb2026 } from "./assets";

const mindfulnessAppsCards = [
  {
    title: "Mindfulness Coach",
    href: "https://www.ptsd.va.gov/appvid/mobile/mindfulcoach_app.asp",
    img: `${S3}/MindfulnessCoach_app_logo.png`,
  },
  {
    title: "Smiling Mind",
    href: "https://www.smilingmind.com.au/",
    img: thumb2026("Pre-Surgical App Smiling Mind.png"),
  },
  {
    title: "UCLA Mindful",
    href: "https://www.uclahealth.org/uclamindful/ucla-mindful-app",
    // Misnamed on S3 (see note above): this file is the UCLA Mindful icon.
    img: thumb2026("Pre-Surgical App Mindfulness Coach.png"),
  },
  {
    title: "Healthy Minds Program",
    href: "https://www.humin.org/wellbeing-tools/app",
    img: `${S3}/HealthyMinds_app_logo..jpeg`,
  },
  {
    title: "Insight Timer",
    href: "https://insighttimer.com/",
    // Shad's dark icon (10/8), replaces the white framed version.
    img: thumb2026("Pre-Surgical App Insight Timer Dark.png"),
  },
];

export default mindfulnessAppsCards;
